<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">单笔支付制单</h1>
        <p class="text-gray-600">提交单笔支付指令，生成支付单。</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                单笔支付接口，执行支付操作，包括从付款账户到收款账户的资金转移。
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full"
                  >POST</span
                >
                <code class="text-sm font-mono">/api/v2/payment/commonPay</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            Content-Type
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            发送内容类型
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            application/json
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            xencio-key
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            加密密钥，当启用国密加密的时候 该请求头必传
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            BM/UBCOn2yrZINuOdvaS01KjftyyRagN/LU2zVntwD8svrIObu/2Sqjl041C3RyqsUlE02ERmRBNgoPcoyhM7Tm1Quv55QcQ9hDNX0GO3997OANU7HQGHYlJ2aDEf0pTGNC0Lu5CzAwSM76dTorLyGI=
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            businessTransNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            外部交易流水号，注：业务唯一编号，长度<=100
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            TRANS2025102400002
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            payAmount
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            转账金额，注：单位（元），保留两位小数
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            150000
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            crossBank
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            跨行标识，注：0 - 本行, 1 - 他行
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">0</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            fromAccountNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            付款账号，注：中间不要有“空格”
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            1001752112100045775
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            fromAccountName
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            付款账户名称
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            XX账户名称
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            toAccountNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            收款账号，注：中间不要有“空格”
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            11011038075301
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            toAccountName
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            收款账户名称
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            中国南方电网有限责任公司
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            toAccountType
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            收款账户类型，注：0 - 对公账号, 1 - 对私账号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">0</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            toBankName
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            特定条件必填
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            收款账户开户行银行名称或支行名称
                            注：同行支付时选填；跨行支付时，开户行名称和开户行号需要填写
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            平安银行沈阳行号
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            toBankNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            特定条件必填
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            收款账户开户行支行号（人行现代支付系统行号）
                            注：同行支付时选填，跨行支付时，开户行名称和开户行号需要填写
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            100324
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            scheduleDate
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            预约日期，需大于当日（格式：yyyyMMdd），暂时仅支持三井银行，瑞穗银行，中国银行
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            20250901
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            purpose
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            特定条件必填
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            用途 注：不得有非法字符，填写规则详见附录4.2
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">转账</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            postscript
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            特定条件必填
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            附言 注：不得有非法字符，填写规则详见附录4.2
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            XXXX附言
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            summary
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            特定条件必填
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            摘要 注：不得有非法字符，填写规则详见附录4.2
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            YYYY摘要
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            metaJson
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            扩展字段 注：json字符串; projectInfo-项目信息
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            {"projectInfo":"测试项目信息"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    eBopInfo
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="param in eBopInfoDocParams" :key="param.name">
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            {{ param.name }}
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            {{ param.type }}
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            {{ param.required }}
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            {{ param.description }}
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            {{ param.example }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回码：200 或 400
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">200</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            message
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            描述信息
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            受理成功
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.businessTransNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            外部交易流水号（回显）
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            TRANS2025102400002
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.paySerialNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            内部交易流水号，资金系统返回
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            BEC-2510241115150001
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.trxNumber
                          </td>
                          <td
                            class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            上送银行指令号
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            2510241629028471
                          </td>
                        </tr>
                        <!-- <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.paymentOrderId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            否
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            平台支付单号（新生成）
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            PO202510240001
                          </td>
                        </tr> -->
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            realJsonModel
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回数据结构 是否json数据
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">true</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            status
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            http状态码
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">200</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            successResponse
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Boolean
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            是否成功
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">true</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-3">附录</h3>
            <div class="overflow-x-auto">
              <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      序号
                    </th>
                    <th
                      class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      描述
                    </th>
                    <th
                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      内容
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr>
                    <td
                      class="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      4.2
                    </td>
                    <td
                      class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      条件必填参数规则
                    </td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                      ---待后续根据每家银行的具体要求陆续完善
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      4.3
                    </td>
                    <td
                      class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                      预约日期支持银行清单
                    </td>
                    <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                      ---待后续根据每家银行的具体要求陆续完善
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>使用不同语言测试API</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <!-- 国密加密开关 -->
                <label class="inline-flex items-center gap-2 mb-3 select-none">
                  <input
                    type="checkbox"
                    v-model="enableGm"
                    class="rounded border-gray-300 text-[var(--primary)] focus:ring-[var(--primary)]"
                  />
                  <span class="text-sm text-gray-700"
                    >启用国密加密（SM2/SM3/SM4）</span
                  >
                  <button
                    type="button"
                    class="ml-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-700 text-xs font-bold hover:bg-blue-200"
                    @click="showGmHelp = true"
                    aria-label="查看国密加密传输说明"
                  >
                    ?
                  </button>
                </label>
                <pre
                  v-if="!enableGm"
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <pre
                  v-if="enableGm"
                  class="bg-gray-900 text-gray-100 p-4 rounded-md text-sm overflow-x-auto mt-3"
                ><code>{{ getGmSampleText() }}</code></pre>
                <!-- 国密说明弹框 -->
                <div v-if="showGmHelp" class="fixed inset-0 z-50">
                  <div
                    class="absolute inset-0 bg-black/40"
                    @click="showGmHelp = false"
                  ></div>
                  <div
                    class="absolute inset-0 flex items-center justify-center p-4"
                  >
                    <div
                      class="w-full max-w-[90vw] md:max-w-2xl rounded-lg bg-white shadow-xl max-h-[85vh] flex flex-col"
                    >
                      <div
                        class="px-4 py-3 border-b border-gray-200 flex items-center justify-end"
                      >
                        <h3 class="sr-only">国密加密传输说明</h3>
                        <button
                          type="button"
                          class="p-1 rounded hover:bg-gray-100"
                          @click="showGmHelp = false"
                        >
                          ✕
                        </button>
                      </div>
                      <div class="px-4 py-4 overflow-y-auto">
                        <GmHelpContent />
                      </div>
                      <div
                        class="px-4 py-3 border-t border-gray-200 flex justify-end"
                      >
                        <button
                          type="button"
                          class="px-3 py-1.5 rounded bg-[var(--primary)] text-white hover:opacity-90"
                          @click="showGmHelp = false"
                        >
                          关闭
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 国密加密开关与密钥输入 -->
                <div
                  v-if="enableGm"
                  class="pt-2 border-t border-gray-200"
                  style="margin-bottom: 0.5rem"
                >
                  <div
                    class="mt-4 rounded-lg border border-gray-200 bg-gray-50"
                  >
                    <div class="flex items-center justify-between px-3 py-2">
                      <div class="text-sm font-medium text-gray-800">
                        国密加密传输（SM2/SM3/SM4）
                      </div>
                      <span
                        v-if="enableGm"
                        class="text-xs px-2 py-0.5 rounded bg-green-100 text-green-700"
                        >已启用</span
                      >
                    </div>
                    <div class="flex items-center justify-between px-3 py-2">
                      <a
                        :href="getBaseDomain() + '/#/app-params'"
                        target="_blank"
                        class="card-link"
                        style="
                          color: var(--primary);
                          font-weight: 500;
                          font-style: italic;
                        "
                      >
                        <KeyOutlined class="w-4 h-4" />
                        获取/配置密钥
                      </a>
                    </div>
                    <div class="px-3 pb-3">
                      <div class="grid grid-cols-1 gap-3">
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >平台公钥（SM2 公钥，Base64）</label
                          >
                          <textarea
                            v-model="xencioPublicKey"
                            rows="3"
                            class="w-full px-3 py-2 font-mono tracking-wider border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)] resize-y"
                            placeholder="粘贴见知提供的 SM2 公钥（Base64，标准编码）"
                          ></textarea>
                          <div class="mt-1 flex items-center justify-between">
                            <p class="text-xs text-gray-500">
                              用于加密 <code>reqData</code>、<code>sign</code>
                              以及 Header <code>xencio-key</code>。
                            </p>
                            <div class="flex items-center gap-2">
                              <span
                                v-if="
                                  xencioPublicKey && isBase64(xencioPublicKey)
                                "
                                class="text-xs px-1.5 py-0.5 rounded bg-green-100 text-green-700"
                                >Base64格式正确</span
                              >
                              <span
                                v-else-if="
                                  xencioPublicKey && !isBase64(xencioPublicKey)
                                "
                                class="text-xs px-1.5 py-0.5 rounded bg-red-100 text-red-700"
                                >Base64格式错误</span
                              >
                              <button
                                type="button"
                                class="text-xs text-gray-500 hover:text-gray-700"
                                @click="xencioPublicKey = ''"
                              >
                                清空
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label
                            class="block text-sm font-medium text-gray-700 mb-1"
                            >企业 SM2 私钥（Base64）</label
                          >
                          <textarea
                            v-model="sm2PrivateKey"
                            rows="3"
                            class="w-full px-3 py-2 font-mono tracking-wider border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)] resize-y"
                            placeholder="粘贴企业自有 SM2 私钥（Base64，标准编码）"
                          ></textarea>
                          <div class="mt-1 flex items-center justify-between">
                            <p class="text-xs text-gray-500">
                              用于解密响应 <code>respData</code>、<code
                                >sign</code
                              >
                              以及 Header <code>xencio-key</code>。
                            </p>
                            <div class="flex items-center gap-2">
                              <span
                                v-if="sm2PrivateKey && isBase64(sm2PrivateKey)"
                                class="text-xs px-1.5 py-0.5 rounded bg-green-100 text-green-700"
                                >Base64格式正确</span
                              >
                              <span
                                v-else-if="
                                  sm2PrivateKey && !isBase64(sm2PrivateKey)
                                "
                                class="text-xs px-1.5 py-0.5 rounded bg-red-100 text-red-700"
                                >Base64格式错误</span
                              >
                              <button
                                type="button"
                                class="text-xs text-gray-500 hover:text-gray-700"
                                @click="sm2PrivateKey = ''"
                              >
                                清空
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code</label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >businessTransNo</label
                    >
                    <input
                      v-model="businessTransNo"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="TRANS2025102400002"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >payAmount</label
                    >
                    <input
                      v-model="payAmount"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="150000"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >crossBank</label
                    >
                    <input
                      v-model="crossBank"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="0"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >fromAccountNo</label
                    >
                    <input
                      v-model="fromAccountNo"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="1001752112100045775"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >fromAccountName</label
                    >
                    <input
                      v-model="fromAccountName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="XX账户名称"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >toAccountNo</label
                    >
                    <input
                      v-model="toAccountNo"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="11011038075301"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >toAccountName</label
                    >
                    <input
                      v-model="toAccountName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="中国南方电网有限责任公司"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >toAccountType</label
                    >
                    <input
                      v-model="toAccountType"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="0"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >toBankName</label
                    >
                    <input
                      v-model="toBankName"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="平安银行沈阳行号"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >toBankNo</label
                    >
                    <input
                      v-model="toBankNo"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="100324"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >scheduleDate</label
                    >
                    <input
                      v-model="scheduleDate"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="20250901"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >purpose</label
                    >
                    <input
                      v-model="purpose"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="转账"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >postscript</label
                    >
                    <input
                      v-model="postscript"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="XXXX附言"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700"
                      >summary</label
                    >
                    <input
                      v-model="summary"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder="YYYY摘要"
                    />
                  </div>
                  <div class="col-span-2">
                    <label class="block text-sm font-medium text-gray-700"
                      >metaJson</label
                    >
                    <textarea
                      v-model="metaJson"
                      rows="3"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      placeholder='{"projectInfo":"测试项目信息"}'
                    ></textarea>
                  </div>

                  <div>
                    <h4 class="text-sm font-semibold mb-2 text-gray-700">eBopInfo</h4>
                    <div class="mb-3 rounded-lg">
                      <div class="grid grid-cols-1 gap-3">
                        <div
                          v-for="field in eBopFormGroup.fields"
                          :key="joinFieldPath(eBopFormGroup.pathPrefix, field.path)"
                        >
                          <label class="block text-sm font-medium text-gray-700 mb-1">
                            {{ field.path }}
                          </label>
                          <input
                            :value="fieldGet(joinFieldPath(eBopFormGroup.pathPrefix, field.path))"
                            type="text"
                            :placeholder="field.placeholder"
                            @input="fieldSet(joinFieldPath(eBopFormGroup.pathPrefix, field.path), ($event.target as HTMLInputElement).value)"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 生成国密SM2公私钥 -->
                  <!-- <div class="mt-2 rounded-md border border-gray-200 bg-white/60">
                    <div class="px-3 py-2 flex items-center justify-between">
                      <span class="text-sm font-medium text-gray-800">生成国密 SM2 公私钥（HEX）</span>
                      <div class="flex items-center gap-2">
                        <button
                          type="button"
                          class="text-xs px-2 py-1 rounded bg-[var(--primary)] text-white hover:opacity-90"
                          @click="generateSm2Keypair"
                        >生成</button>
                        <button
                          type="button"
                          class="text-xs px-2 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300"
                          @click="fillGeneratedKeys"
                          :disabled="!generatedSm2PublicKey || !generatedSm2PrivateKey"
                        >一键填入上方</button>
                      </div>
                    </div>
                    <div class="px-3 pb-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label class="block text-xs text-gray-700 mb-1">SM2 公钥（未压缩，HEX）</label>
                        <textarea
                          v-model="generatedSm2PublicKey"
                          rows="3"
                          readonly
                          class="w-full px-3 py-2 font-mono text-xs bg-gray-100 border border-gray-200 rounded-md"
                        ></textarea>
                        <div class="mt-1 flex items-center justify-between">
                          <span class="text-xs text-gray-500">用于加密 Header xencio-key</span>
                          <button
                            type="button"
                            class="text-xs text-blue-600 hover:text-blue-800"
                            @click="copyText(generatedSm2PublicKey)"
                            :disabled="!generatedSm2PublicKey"
                          >复制</button>
                        </div>
                      </div>
                      <div>
                        <label class="block text-xs text-gray-700 mb-1">SM2 私钥（HEX）</label>
                        <textarea
                          v-model="generatedSm2PrivateKey"
                          rows="3"
                          readonly
                          class="w-full px-3 py-2 font-mono text-xs bg-gray-100 border border-gray-200 rounded-md"
                        ></textarea>
                        <div class="mt-1 flex items-center justify-between">
                          <span class="text-xs text-gray-500">用于签名和解密响应</span>
                          <button
                            type="button"
                            class="text-xs text-blue-600 hover:text-blue-800"
                            @click="copyText(generatedSm2PrivateKey)"
                            :disabled="!generatedSm2PrivateKey"
                          >复制</button>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- 国密加密快速测试（最简） -->
                  <!-- <div class="mt-4 rounded-md border border-blue-200 bg-blue-50/50">
                    <div class="px-3 py-2 flex items-center justify-between">
                      <span class="text-sm font-medium text-blue-800">国密加密快速测试（最简）</span>
                      <button
                        type="button"
                        class="text-xs px-2 py-1 rounded bg-blue-600 text-white hover:bg-blue-700"
                        @click="testGmEncrypt"
                      >执行加密</button>
                    </div>
                    <div class="px-3 pb-3 space-y-2">
                      <div>
                        <label class="block text-xs text-blue-700 mb-1">原始 JSON</label>
                        <textarea
                          v-model="gmTestOriginal"
                          rows="3"
                          class="w-full px-3 py-2 font-mono text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                          placeholder='{"echo":"gm-test","n":1}'
                        ></textarea>
                      </div>
                      <div v-if="gmTestError" class="text-xs text-red-600">{{ gmTestError }}</div>
                      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div>
                          <label class="block text-xs text-blue-700 mb-1">reqData（SM2加密SM4密文）</label>
                          <textarea
                            v-model="gmTestReqData"
                            rows="3"
                            readonly
                            class="w-full px-3 py-2 font-mono text-xs bg-gray-100 border border-gray-200 rounded-md"
                          ></textarea>
                        </div>
                        <div>
                          <label class="block text-xs text-blue-700 mb-1">sign（SM2加密SM3摘要）</label>
                          <textarea
                            v-model="gmTestSign"
                            rows="3"
                            readonly
                            class="w-full px-3 py-2 font-mono text-xs bg-gray-100 border border-gray-200 rounded-md"
                          ></textarea>
                        </div>
                        <div>
                          <label class="block text-xs text-blue-700 mb-1">xencio-key（SM2加密SM4密钥）</label>
                          <textarea
                            v-model="gmTestXencioKey"
                            rows="3"
                            readonly
                            class="w-full px-3 py-2 font-mono text-xs bg-gray-100 border border-gray-200 rounded-md"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <button
                    @click="submitPayment"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "提交中..." : "发起支付制单请求" }}
                  </button>
                </div>
              </div>

              <!-- 响应结果 -->
              <div v-if="response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import GmHelpContent from "./ui/GmHelpContent.vue";
import { ref, onMounted, watch, nextTick } from "vue";
import Sidebar from "./Sidebar.vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";
import CryptoJS from "crypto-js";
import { useSystemStore } from "@/stores/system";
import { getBaseDomain } from "@/lib/config";
import { Base64 } from "js-base64";
import * as sm from "sm-crypto";
import * as Buffer from "buffer";
import { get as lodashGet, set as lodashSet } from "lodash";
const serverUrl = import.meta.env.VITE_API_URL;
// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      // 处理所有代码块
      allCodeBlocks.forEach((block) => {
        // 清除之前的高亮
        block.className = "";
        block.removeAttribute("data-highlighted");

        // 重新添加基础类和语言类
        block.classList.add("hljs");
        if (langClass) {
          block.classList.add(langClass);
        }

        try {
          hljs.highlightElement(block as HTMLElement);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100); // 减少延迟时间
  });
};

// 初始化代码高亮
highlightCode();

// 系统配置
const systemStore = useSystemStore();

// 默认值
const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";
const DEFAULT_XENCIO_PUBLIC_KEY = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const xencioPublicKey = ref(DEFAULT_XENCIO_PUBLIC_KEY);
// 支付制单字段
const acceptHeader = ref("application/json");
const fromAccountNo = ref("");
const fromAccountName = ref("");
const toAccountNo = ref("");
const toAccountName = ref("");
const businessTransNo = ref("");
const payAmount = ref("");
const crossBank = ref("0");
const toAccountType = ref("0");
const toBankName = ref("");
const toBankNo = ref("");
const scheduleDate = ref("");
const purpose = ref("");
const postscript = ref("");
const summary = ref("");
const metaJson = ref("");

type EBopInfoState = {
  paymentType: string;
  unitCode: string;
  residentCountry: string;
  residentCountryName: string;
  paymentUnderBondedGoods: string;
  paymentTerm: string;
  paymentNature: string;
  transactionCode1: string;
  transactionRemark1: string;
  amount1: string;
  currency1: string;
  transactionCode2: string;
  transactionRemark2: string;
  amount2: string;
  currency2: string;
  contractNo: string;
  invoiceNo: string;
  safeApprovalNo: string;
};

const initialEBopInfoState = (): EBopInfoState => ({
  paymentType: "",
  unitCode: "",
  residentCountry: "",
  residentCountryName: "",
  paymentUnderBondedGoods: "",
  paymentTerm: "",
  paymentNature: "",
  transactionCode1: "",
  transactionRemark1: "",
  amount1: "",
  currency1: "",
  transactionCode2: "",
  transactionRemark2: "",
  amount2: "",
  currency2: "",
  contractNo: "",
  invoiceNo: "",
  safeApprovalNo: "",
});

const eBopInfo = ref<EBopInfoState>(initialEBopInfoState());

const eBopInfoDocParams = [
  { name: "paymentType", type: "String", required: "否", description: "付款类型：O=海外外币，D=国内外币，X=跨境人民币", example: "" },
  { name: "unitCode", type: "String", required: "否", description: "主体标识码/组织机构代码", example: "" },
  { name: "residentCountry", type: "String", required: "否", description: "收款人常驻国家（地区）代码", example: "" },
  { name: "residentCountryName", type: "String", required: "否", description: "收款人常驻国家名称（运行时回填）", example: "" },
  { name: "paymentUnderBondedGoods", type: "String", required: "否", description: "是否为报税货物项下付款：Y=是，N=否", example: "" },
  { name: "paymentTerm", type: "String", required: "否", description: "付款方式：A=预付货款，P=货到付款，R=退款，O=其他", example: "" },
  { name: "paymentNature", type: "String", required: "否", description: "付款性质：X=保税区，E=出口加工区，D=钻石交易所，A=其他经济特区，M=深加工结转，O=其他", example: "" },
  { name: "transactionCode1", type: "String", required: "否", description: "BOP 交易代码 1", example: "" },
  { name: "transactionRemark1", type: "String", required: "否", description: "交易备注 1", example: "" },
  { name: "amount1", type: "String", required: "否", description: "金额 1", example: "" },
  { name: "currency1", type: "String", required: "否", description: "币种 1", example: "" },
  { name: "transactionCode2", type: "String", required: "否", description: "BOP 交易代码 2", example: "" },
  { name: "transactionRemark2", type: "String", required: "否", description: "交易备注 2", example: "" },
  { name: "amount2", type: "String", required: "否", description: "金额 2", example: "" },
  { name: "currency2", type: "String", required: "否", description: "币种 2", example: "" },
  { name: "contractNo", type: "String", required: "否", description: "合同号", example: "" },
  { name: "invoiceNo", type: "String", required: "否", description: "发票编号", example: "" },
  { name: "safeApprovalNo", type: "String", required: "否", description: "备案号/安全批准号/参考号", example: "" },
];

type EBopFormField = {
  path: string;
  placeholder: string;
};

const eBopFormGroup = {
  title: "eBopInfo",
  pathPrefix: "eBopInfo",
  fields: [
    { path: "paymentType", placeholder: "O/D/X（海外外币/国内外币/跨境人民币）" },
    { path: "unitCode", placeholder: "主体标识码/组织机构代码" },
    { path: "residentCountry", placeholder: "收款人常驻国家代码" },
    { path: "residentCountryName", placeholder: "收款人常驻国家名称" },
    { path: "paymentUnderBondedGoods", placeholder: "报税货物项下付款 Y/N" },
    { path: "paymentTerm", placeholder: "付款方式 A/P/R/O" },
    { path: "paymentNature", placeholder: "付款性质 X/E/D/A/M/O" },
    { path: "transactionCode1", placeholder: "BOP 交易代码 1" },
    { path: "transactionRemark1", placeholder: "交易备注 1" },
    { path: "amount1", placeholder: "金额 1" },
    { path: "currency1", placeholder: "币种 1" },
    { path: "transactionCode2", placeholder: "BOP 交易代码 2" },
    { path: "transactionRemark2", placeholder: "交易备注 2" },
    { path: "amount2", placeholder: "金额 2" },
    { path: "currency2", placeholder: "币种 2" },
    { path: "contractNo", placeholder: "合同号" },
    { path: "invoiceNo", placeholder: "发票编号" },
    { path: "safeApprovalNo", placeholder: "备案号/安全批准号" },
  ] as EBopFormField[],
};

const joinFieldPath = (pathPrefix: string | undefined, path: string) => {
  const p = (pathPrefix ?? "").trim();
  return p ? `${p}.${path}` : path;
};

const fieldGet = (path: string) => {
  const v = lodashGet(eBopInfo.value, path.replace(/^eBopInfo\./, ""));
  if (v === undefined || v === null) return "";
  return String(v);
};

const fieldSet = (path: string, val: string) => {
  lodashSet(
    eBopInfo.value as unknown as Record<string, unknown>,
    path.replace(/^eBopInfo\./, ""),
    val
  );
};

const deepOmitEmptyStrings = (obj: unknown): unknown => {
  if (obj === null || obj === undefined) return undefined;
  if (typeof obj === "string") return obj.trim() === "" ? undefined : obj;
  if (typeof obj !== "object") return obj;
  if (Array.isArray(obj)) {
    const arr = (obj as unknown[])
      .map(deepOmitEmptyStrings)
      .filter((x) => x !== undefined);
    return arr.length ? arr : undefined;
  }
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
    const p = deepOmitEmptyStrings(v);
    if (p === undefined) continue;
    if (
      typeof p === "object" &&
      p !== null &&
      !Array.isArray(p) &&
      Object.keys(p as object).length === 0
    )
      continue;
    out[k] = p;
  }
  return Object.keys(out).length ? out : undefined;
};

const buildPaymentPayload = (): Record<string, unknown> => {
  const payload: Record<string, unknown> = {
    businessTransNo: businessTransNo.value,
    payAmount: payAmount.value,
    crossBank: crossBank.value,
    fromAccountNo: fromAccountNo.value,
    fromAccountName: fromAccountName.value,
    toAccountNo: toAccountNo.value,
    toAccountName: toAccountName.value,
    toAccountType: toAccountType.value,
    toBankName: toBankName.value,
    toBankNo: toBankNo.value,
    scheduleDate: scheduleDate.value,
    purpose: purpose.value,
    postscript: postscript.value,
    summary: summary.value,
    metaJson: metaJson.value,
  };
  const eBopPruned = deepOmitEmptyStrings(
    JSON.parse(JSON.stringify(eBopInfo.value)) as Record<string, unknown>
  );
  if (
    eBopPruned &&
    typeof eBopPruned === "object" &&
    Object.keys(eBopPruned as object).length
  ) {
    payload.eBopInfo = eBopPruned;
  }
  return payload;
};

// 国密相关
const enableGm = ref(true);
//const xencioPublicKey = ref("");
const sm2PrivateKey = ref("");
// 国密说明弹框显示控制
const showGmHelp = ref(false);

let sm2Lib = sm.sm2;
let sm4Lib = sm.sm4;

const randomSm4Key = () => {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let s = "";
  for (let i = 0; i < 16; i++)
    s += chars[Math.floor(Math.random() * chars.length)];
  return s;
};
const convertUtf82HEX = (utf8: string) => {
  const array = new Uint8Array(utf8.length);
  let hexString: string = "";
  for (let i = 0; i < array.length; i++) {
    hexString += `0${array[i].toString(16)}`.slice(-2);
  }
  return hexString;
};

// Base64校验（标准Base64）
const isBase64 = (s: unknown) => {
  const str = String(s ?? "");
  if (!str || str.length % 4 !== 0) return false;
  if (!/^[A-Za-z0-9+/=]+$/.test(str)) return false;
  try {
    // atob会在非法输入时报错
    atob(str);
    return true;
  } catch {
    return false;
  }
};

const base64ToBytes = (b64: string) => {
  const s = String(b64 || "").replace(/\s+/g, "");
  const pad = s.length % 4 ? "=".repeat(4 - (s.length % 4)) : "";
  const raw = atob(s + pad);
  return new Uint8Array(Array.from(raw).map((c) => c.charCodeAt(0)));
};
const bytesToHex = (arr: Uint8Array) =>
  Array.from(arr)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
const hexToBytes = (hex: string) =>
  new Uint8Array(
    (hex || "").match(/.{1,2}/g)?.map((h) => parseInt(h, 16)) || []
  );
const bytesToBase64 = (arr: Uint8Array) =>
  btoa(String.fromCharCode.apply(null, Array.from(arr) as any));
const hexToBase64 = (hex: string) => bytesToBase64(hexToBytes(hex || ""));
const readDerLength = (buf: Uint8Array, pos: number) => {
  let len = buf[pos];
  pos += 1;
  if ((len & 0x80) !== 0) {
    const n = len & 0x7f;
    let v = 0;
    for (let i = 0; i < n; i++) v = (v << 8) | buf[pos + i];
    pos += n;
    len = v;
  }
  return { len, pos };
};

const spkiBase64ToUncompressedHex = (b64: string) => {
  const outer = base64ToBytes(b64);
  if (outer[0] !== 0x30) throw new Error("公钥DER解析失败: 非SEQUENCE");
  const { len, pos } = readDerLength(outer, 1);
  const content = outer.subarray(pos, pos + len);
  let p = 0;
  if (content[p] !== 0x30) throw new Error("公钥DER解析失败: 算法标识缺失");
  p += 1;
  const r1 = readDerLength(content, p);
  p = r1.pos + r1.len;
  if (content[p] !== 0x03) throw new Error("公钥DER解析失败: 未找到BIT STRING");
  p += 1;
  const r2 = readDerLength(content, p);
  const bitStart = r2.pos;
  const bitLen = r2.len;
  const unused = content[bitStart];
  if (unused !== 0x00) throw new Error("公钥DER解析失败: 非零unused bits");
  const point = content.subarray(bitStart + 1, bitStart + bitLen);
  if (point.length !== 65 || point[0] !== 0x04)
    throw new Error("公钥格式错误: 需非压缩点");
  return bytesToHex(point);
};
const pkcs8Base64ToPrivateKeyHex = (b64: string) => {
  const buf = base64ToBytes(b64);
  let p = 0;
  if (buf[p++] !== 0x30) throw new Error("私钥DER解析失败: 非SEQUENCE");
  let r = readDerLength(buf, p);
  const end = r.pos + r.len;
  p = r.pos;
  if (buf[p++] !== 0x02) throw new Error("私钥DER解析失败: 缺少版本INTEGER");
  r = readDerLength(buf, p);
  p = r.pos + r.len;
  if (buf[p++] !== 0x30) throw new Error("私钥DER解析失败: 缺少算法SEQUENCE");
  r = readDerLength(buf, p);
  p = r.pos + r.len;
  if (buf[p++] !== 0x04) throw new Error("私钥DER解析失败: 未找到OCTET STRING");
  r = readDerLength(buf, p);
  const ecStart = r.pos;
  const ecLen = r.len;
  const ec = buf.subarray(ecStart, ecStart + ecLen);
  let q = 0;
  if (ec[q++] !== 0x30)
    throw new Error("私钥DER解析失败: 非ECPrivateKey SEQUENCE");
  let r2 = readDerLength(ec, q);
  const ecEnd = r2.pos + r2.len;
  q = r2.pos;
  if (ec[q++] !== 0x02) throw new Error("私钥DER解析失败: 缺少EC版本INTEGER");
  r2 = readDerLength(ec, q);
  q = r2.pos + r2.len;
  if (ec[q++] !== 0x04)
    throw new Error("私钥DER解析失败: 未找到ECPrivateKey OCTET STRING");
  r2 = readDerLength(ec, q);
  const privStart = r2.pos;
  const privLen = r2.len;
  let priv = ec.subarray(privStart, privStart + privLen);
  if (priv.length > 32) priv = priv.slice(priv.length - 32);
  if (priv.length < 32)
    priv = new Uint8Array([
      ...new Array(32 - priv.length).fill(0),
      ...Array.from(priv),
    ]);
  return bytesToHex(priv as Uint8Array);
};
const normalizeSm2PublicHex = (s: string) => {
  if (isBase64(s)) return spkiBase64ToUncompressedHex(s);
  return s;
};
const normalizeSm2PrivateHex = (s: string) => {
  if (isBase64(s)) return pkcs8Base64ToPrivateKeyHex(s);
  return s;
};

// 国密加密快速测试（最简）
const gmTestOriginal = ref('{"echo":"gm-test","n":1}');
const gmTestReqData = ref("");
const gmTestSign = ref("");
const gmTestXencioKey = ref("");
const gmTestError = ref("");
// 生成的 SM2 密钥对
const generatedSm2PublicKey = ref("");
const generatedSm2PrivateKey = ref("");
const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text || "");
    alert("已复制到剪贴板");
  } catch (e) {
    console.warn("复制失败", e);
  }
};
const generateSm2Keypair = async () => {
  try {
    const pair = sm2Lib.generateKeyPairHex();
    generatedSm2PublicKey.value = pair?.publicKey || "";
    generatedSm2PrivateKey.value = pair?.privateKey || "";
  } catch (e) {
    console.error("生成SM2密钥失败", e);
  }
};
const fillGeneratedKeys = () => {
  if (generatedSm2PublicKey.value) {
    xencioPublicKey.value = generatedSm2PublicKey.value;
  }
  if (generatedSm2PrivateKey.value) {
    sm2PrivateKey.value = generatedSm2PrivateKey.value;
  }
};
// 加密
// value：需要加密的内容
function sm2Encrypt(value, publicKey: string) {
  // 给后端传值时需要在加密的密文前面加04 ,这样后端才能解密正确不报错
  return `04${sm2Lib.doEncrypt(value, publicKey, 1)}`;
}

// 解密
// value：需要解密的密文
function sm2Decrypt(value, privateKey: string) {
  // 后端传输过来的密文开头的两个字符通常也为04，因此解密时需要删除
  return sm2Lib.doDecrypt(value?.slice(2, value.length), privateKey, 1);
}
const testGmEncrypt = async () => {
  gmTestError.value = "";
  gmTestReqData.value = "";
  gmTestSign.value = "";
  gmTestXencioKey.value = "";
  try {
    if (!xencioPublicKey.value) {
      gmTestError.value = "请填写见知公钥（Base64）";
      return;
    }
    if (!isBase64(xencioPublicKey.value)) {
      gmTestError.value = "见知公钥格式错误：需为Base64";
      return;
    }
    const xencioPubHex = normalizeSm2PublicHex(xencioPublicKey.value);
    const raw = gmTestOriginal.value || "";
    const sm4Key = randomSm4Key();
    console.log("sm4Key:", sm4Key);
    gmTestReqData.value = sm4Lib.encrypt(sm4Key, raw) || "";
    gmTestSign.value = sm2Lib.doSignature(raw, sm2PrivateKey, 1) || "";
    gmTestXencioKey.value = sm2Lib.doEncrypt(sm4Key, xencioPubHex, 1) || "";
  } catch (e) {
    console.error("加密失败:", e);
    gmTestError.value = "加密失败：" + (e as Error).message;
  }
};

const loading = ref(false);
const response = ref("");
const activeLanguage = ref("curl");

// （移除重复定义）

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
        xencioPublicKey: response.xencioPublicKey,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>(
      "/nxb/console/customer/listWithSummary",
      {
        pageNow: 1,
        pageSize: 10,
      }
    );

    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    // 获取应用信息
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
      xencioPublicKey.value = appInfo.xencioPublicKey;
    }

    // 获取客户信息
    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [appId, authorization, customerCode, activeLanguage, response, enableGm, eBopInfo],
  () => {
    highlightCode();
  },
  { flush: "post", deep: true }
);

// 根据 appId、trxNumber、payAmount 自动计算 securityCode（MD5并大写）
watch(
  [appId, businessTransNo, payAmount],
  () => {
    const base = `${appId.value}${businessTransNo.value}${payAmount.value}`;
  },
  { immediate: true }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 获取请求文本
const getRequestText = () => {
  const payloadJson = JSON.stringify(buildPaymentPayload());
  // 根据当前语言生成支付制单的示例代码
  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X POST '${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay' \n` +
        `  -H 'x-app-id: ${appId.value}' \n` +
        `  -H 'x-app-secret: ${authorization.value}' \n` +
        `  -H 'x-customer-code: ${customerCode.value}' \n` +
        `  -H 'Content-Type: application/json' \n` +
        `  -d '${payloadJson}'`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const data = ${JSON.stringify(buildPaymentPayload(), null, 2)};\n\n` +
        `const config = {\n` +
        `  method: 'post',\n` +
        `  url: '${import.meta.env.VITE_API_URL}/api/v2/payment/commonPay',\n` +
        `  headers: { \n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}',\n` +
        `    'Content-Type': 'application/json'\n` +
        `  },\n` +
        `  data: data\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    console.log(JSON.stringify(response.data));\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n` +
        `import json\n\n` +
        `url = "${import.meta.env.VITE_API_URL}/api/v2/payment/commonPay"\n\n` +
        `payload = ${JSON.stringify(buildPaymentPayload(), null, 2)}\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}',\n` +
        `  'Content-Type': 'application/json'\n` +
        `}\n\n` +
        `response = requests.request("POST", url, headers=headers, data=json.dumps(payload))\n\n` +
        `print(response.text)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `MediaType mediaType = MediaType.parse("application/json");\n` +
        `String json = ${JSON.stringify(JSON.stringify(buildPaymentPayload()))};\n` +
        `RequestBody body = RequestBody.create(mediaType, json);\n` +
        `Request request = new Request.Builder()\n` +
        `  .url("${import.meta.env.VITE_API_URL}/api/v2/payment/commonPay")\n` +
        `  .method("POST", body)\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .addHeader("Content-Type", "application/json")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();`
      );

    case "csharp":
      return (
        `var client = new RestClient("${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay");\n` +
        `var request = new RestRequest(Method.POST);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("x-customer-code", "${customerCode.value}");\n` +
        `request.AddHeader("Content-Type", "application/json");\n` +
        `request.AddJsonBody(${JSON.stringify(buildPaymentPayload())});\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `Console.WriteLine(response.Content);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_ENCODING => '',\n` +
        `  CURLOPT_MAXREDIRS => 10,\n` +
        `  CURLOPT_TIMEOUT => 0,\n` +
        `  CURLOPT_FOLLOWLOCATION => true,\n` +
        `  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'POST',\n` +
        `  CURLOPT_POSTFIELDS => '${payloadJson.replace(/\\/g, "\\\\").replace(/'/g, "\\'")}',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}',\n` +
        `    'Content-Type: application/json'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n\n` +
        `curl_close($curl);\n` +
        `echo $response;`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n\n` +
        `url = URI("${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay")\n\n` +
        `https = Net::HTTP.new(url.host, url.port);\n` +
        `https.use_ssl = true\n\n` +
        `request = Net::HTTP::Post.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n` +
        `request["Content-Type"] = "application/json"\n` +
        `request.body = ${JSON.stringify(JSON.stringify(buildPaymentPayload()))}\n\n` +
        `response = https.request(request)\n` +
        `puts response.read_body`
      );

    default:
      return "";
  }
};

// 国密加密示例：按当前语言生成（每种语言使用自身库/API）
const getGmSampleText = () => {
  switch (activeLanguage.value) {
    case "curl":
      return (
        `# 新流程：\n` +
        `# 1) 生成 16 位字母数字 SM4 密钥 sm4Key\n` +
        `# 2) reqData = SM4_Encrypt(JSON(original), sm4Key)\n` +
        `# 3) sign = SM2_Sign(SM3(JSON(original)), enterprisePrivateKey)\n` +
        `# 4) xencio-key = SM2_Encrypt(sm4Key, xencioPublicKey)\n\n` +
        `curl --location '${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay' \\\n` +
        `  --header 'x-app-id: ${appId.value}' \\\n` +
        `  --header 'x-app-secret: ${authorization.value}' \\\n` +
        `  --header 'x-customer-code: ${customerCode.value}' \\\n` +
        `  --header 'Content-Type: application/json' \\\n` +
        `  --header 'xencio-key: <SM2_Encrypt(sm4Key)>' \\\n` +
        `  --data '{"reqData":"<SM4_Encrypt(original, sm4Key)>","sign":"<SM2_Sign(SM3(original), enterprisePrivateKey)>"}'`
      );

    case "javascript":
      return (
        `import { sm2 as sm2Lib, sm3 as sm3Lib, sm4 as sm4Lib } from 'sm-crypto';\n` +
        `import axios from 'axios';\n\n` +
        `// 注意：密钥为 Base64，需要转换为 HEX 供 sm-crypto 使用\n` +
        `const b64ToHex = (b64) => Buffer.from(b64, 'base64').toString('hex');\n\n` +
        `// 生成 16 位字母数字 SM4 密钥\n` +
        `const genSm4Key = () => Array.from({length:16},()=>('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random()*62)])).join('');\n` +
        `const sm4Key = genSm4Key();\n\n` +
        `const originalObj = ${JSON.stringify(buildPaymentPayload(), null, 2)};\n` +
        `const original = JSON.stringify(originalObj);\n` +
        `// sm4 密钥需为 32 位 HEX\n` +
        `const sm4KeyHex = Buffer.from(sm4Key, 'utf8').toString('hex');\n` +
        `const reqData = sm4Lib.encrypt(original, sm4KeyHex);\n` +
        `const signDigest = sm3Lib(original);\n\n` +
        `const xencioPubHex = b64ToHex('${xencioPublicKey.value}');\n` +
        `const sm2PrivHex = b64ToHex('${sm2PrivateKey.value}');\n` +
        `const sign = sm2Lib.doSignature(signDigest, sm2PrivHex, { hash: false });\n` +
        `const xencioKeyHeader = sm2Lib.doEncrypt(sm4Key, xencioPubHex, 1);\n\n` +
        `const headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}',\n` +
        `  'Content-Type': 'application/json',\n` +
        `  'xencio-key': xencioKeyHeader,\n` +
        `};\n` +
        `axios.post('${
          import.meta.env.VITE_API_URL
        }/api/v2/payment/commonPay', { reqData, sign }, { headers })\n` +
        `  .then(resp => {\n` +
        `    // 响应解密与验签\n` +
        `    const encKey = resp.headers['xencio-key'] || '';\n` +
        `    const sm4KeyResp = sm2Lib.doDecrypt(encKey, sm2PrivHex, 1);\n` +
        `    const originResp = sm4Lib.decrypt(resp.data.respData || '', sm4KeyResp || '');\n` +
        `    const calc = sm3Lib(originResp || '');\n` +
        `    const verified = sm2Lib.doVerifySignature(calc, xencioPubHex, (resp.data.sign || ''), { hash: false });\n` +
        `    console.log({ verified, originResp });\n` +
        `  })\n` +
        `  .catch(console.error);`
      );

    case "python":
      return (
        `# pip install gmssl requests\n` +
        `import json, requests, secrets\n` +
        `from gmssl.sm4 import CryptSM4, SM4_ENCRYPT, SM4_DECRYPT\n` +
        `from gmssl.sm3 import sm3_hash\n` +
        `from gmssl.sm2 import CryptSM2\n\n` +
        `def gen_sm4_key():\n` +
        `    return ''.join(secrets.choice('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz') for _ in range(16))\n\n` +
        `sm4_key = gen_sm4_key()\n` +
        `original_obj = ${JSON.stringify(buildPaymentPayload(), null, 2)}\n` +
        `original = json.dumps(original_obj, ensure_ascii=False)\n\n` +
        `sm4 = CryptSM4()\n` +
        `sm4.set_key(sm4_key.encode('utf-8'), SM4_ENCRYPT)\n` +
        `reqData = sm4.crypt_ecb(original.encode('utf-8')).hex()\n\n` +
        `sign_hex = sm3_hash(list(original.encode('utf-8')))\n` +
        `sm2_signer = CryptSM2(public_key='', private_key='${sm2PrivateKey.value}')\n` +
        `sign = sm2_signer.sign(bytes.fromhex(sign_hex))\n\n` +
        `xencio_pub = '${xencioPublicKey.value}'\n` +
        `sm2_enc = CryptSM2(public_key=xencio_pub, private_key='')\n` +
        `xencio_key_header = sm2_enc.encrypt(sm4_key.encode('utf-8')).hex()\n\n` +
        `url = '${import.meta.env.VITE_API_URL}/api/v2/payment/commonPay'\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}',\n` +
        `  'Content-Type': 'application/json',\n` +
        `  'xencio-key': xencio_key_header,\n` +
        `}\n` +
        `payload = json.dumps({ 'reqData': reqData, 'sign': sign }, ensure_ascii=False)\n` +
        `resp = requests.post(url, headers=headers, data=payload)\n` +
        `enc_key_hex = resp.headers.get('xencio-key', '')\n` +
        `sm2_priv = CryptSM2(public_key='', private_key='${sm2PrivateKey.value}')\n` +
        `sm4_key_resp = sm2_priv.decrypt(bytes.fromhex(enc_key_hex)).decode('utf-8')\n` +
        `data = resp.json()\n` +
        `sm4_dec = CryptSM4()\n` +
        `sm4_dec.set_key(sm4_key_resp.encode('utf-8'), SM4_DECRYPT)\n` +
        `origin_resp = sm4_dec.crypt_ecb(bytes.fromhex(data.get('respData',''))).decode('utf-8')\n` +
        `calc_hex = sm3_hash(list(origin_resp.encode('utf-8')))\n` +
        `sm2_pub = CryptSM2(public_key='${xencioPublicKey.value}', private_key='')\n` +
        `verified = sm2_pub.verify(sign, bytes.fromhex(calc_hex))\n` +
        `print({ 'verified': verified, 'originResp': origin_resp })\n`
      );

    case "java":
      return (
        `import java.nio.charset.StandardCharsets;\n` +
        `import java.security.Security;\n` +
        `import java.util.Arrays;\n` +
        `import java.util.Random;\n` +
        `import java.math.BigInteger;\n` +
        `import cn.hutool.core.codec.Base64;\n` +
        `import cn.hutool.core.util.CharsetUtil;\n` +
        `import cn.hutool.core.util.HexUtil;\n` +
        `import cn.hutool.core.util.RandomUtil;\n` +
        `import cn.hutool.core.util.StrUtil;\n` +
        `import cn.hutool.crypto.SmUtil;\n` +
        `import cn.hutool.crypto.asymmetric.KeyType;\n` +
        `import cn.hutool.crypto.asymmetric.SM2;\n` +
        `import cn.hutool.crypto.symmetric.SM4;\n` +
        `import cn.hutool.crypto.symmetric.SymmetricCrypto;\n` +
        `\n` +
        `private String doEcrypt(String message, String xencioPubKey, String customerPrivKey) {\n` +
        `        String sm4Key = RandomUtil.randomString(16);\n` +
        `        logger.info("doEcrypt random sm4Key:{}", sm4Key);\n` +
        `        SymmetricCrypto sm4 = new SM4( sm4Key.getBytes(CharsetUtil.CHARSET_UTF_8));\n` +
        `        byte[] encrypHex = sm4.encrypt(message);\n` +
        `        String reqDataEncrypt = Base64.encode(encrypHex);\n` +
        `        // 2.SM2,对方的公钥对SM4密钥进行加密，并且对报文进行签名。\n` +
        `        SM2 sm2Pri = SmUtil.sm2(customerPrivKey, null);\n` +
        `        String sign = HexUtil.encodeHexStr(sm2Pri.sign(message.getBytes(CharsetUtil.CHARSET_UTF_8)));\n` +
        `        SM2 sm2Pub = SmUtil.sm2(null, xencioPubKey);\n` +
        `        String sm4KeyEncrypt = sm2Pub.encryptBase64(sm4Key, KeyType.PublicKey);\n` +
        `        System.out.println("XENCIO_KEY: "+sm4KeyEncrypt);\n` +
        `        System.out.println("reqData: "+reqDataEncrypt);\n` +
        `        System.out.println("sign: "+sign);\n` +
        `}\n` +
        `\n` +
        `private String doDecrypt(String XENCIO_KEY, String respData, String sign, String xencioPubKey, String customerPrivKey) {\n` +
        `		String sm4KeyEncrypt = XENCIO_KEY;\n` +
        `		String respDataEncrypt = respData;\n` +
        `		// 1.非对称解密：SM2,用私钥解密，得到 SM4密钥\n` +
        `        SM2 sm2 = SmUtil.sm2(customerPrivKey, null);\n` +
        `        String sm4Key = StrUtil.utf8Str(sm2.decrypt(sm4KeyEncrypt, KeyType.PrivateKey));\n` +
        `       // 2.SM4密钥解密报文，得到原始报文\n` +
        `		SymmetricCrypto sm4 = new SM4( sm4Key.getBytes(CharsetUtil.CHARSET_UTF_8));\n` +
        `		String respDataDecrypt = sm4.decryptStr(respDataEncrypt);\n` +
        `		SM2 sm2Pub = SmUtil.sm2(null, xencioPubKey);\n` +
        `       // 3.用对方公钥sign验签\n` +
        `		if (!sm2Pub.verify(respDataDecrypt.getBytes(CharsetUtil.CHARSET_UTF_8), HexUtil.decodeHex(sign))) {		\n` +
        `			throw new RuntimeException("验签失败");\n` +
        `		}\n` +
        `}\n`
      );

    case "csharp":
      return (
        `using System;\n` +
        `using System.Linq;\n` +
        `using System.Text;\n` +
        `using Org.BouncyCastle.Crypto.Digests;\n` +
        `using Org.BouncyCastle.Crypto.Engines;\n` +
        `using Org.BouncyCastle.Crypto.Paddings;\n` +
        `using Org.BouncyCastle.Crypto.Parameters;\n` +
        `using Org.BouncyCastle.Security;\n` +
        `using Org.BouncyCastle.Asn1.GM;\n` +
        `using Org.BouncyCastle.Math;\n` +
        `using Org.BouncyCastle.Math.EC;\n` +
        `using Org.BouncyCastle.Crypto;\n` +
        `using Org.BouncyCastle.Crypto.Signers;\n` +
        `using Org.BouncyCastle.Utilities.Encoders;\n\n` +
        `string GenSm4Key(){ var r=new Random(); var alphabet="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; return new string(Enumerable.Range(0,16).Select(_=>alphabet[r.Next(alphabet.Length)]).ToArray()); }\n` +
        `var sm4Key = GenSm4Key();\n` +
        `byte[] keyBytes = Encoding.UTF8.GetBytes(sm4Key);\n` +
        `string original = "{\\\"businessTransNo\\\":\\\"${businessTransNo.value}\\\",...}"; // 完整 JSON\n` +
        `byte[] plain = Encoding.UTF8.GetBytes(original);\n\n` +
        `var cipher = new PaddedBufferedBlockCipher(new SM4Engine(), new Pkcs7Padding());\n` +
        `cipher.Init(true, new KeyParameter(keyBytes));\n` +
        `byte[] outBuf = new byte[cipher.GetOutputSize(plain.Length)];\n` +
        `int len = cipher.ProcessBytes(plain, 0, plain.Length, outBuf, 0);\n` +
        `len += cipher.DoFinal(outBuf, len);\n` +
        `byte[] sm4Cipher = outBuf.Take(len).ToArray();\n` +
        `string reqData = BitConverter.ToString(sm4Cipher).Replace("-", "").ToLowerInvariant();\n\n` +
        `var sm3 = new SM3Digest();\n` +
        `sm3.BlockUpdate(plain, 0, plain.Length);\n` +
        `byte[] digest = new byte[sm3.GetDigestSize()];\n` +
        `sm3.DoFinal(digest, 0);\n\n` +
        `var curve = GMNamedCurves.GetByName("sm2p256v1");\n` +
        `var d = new BigInteger("${sm2PrivateKey.value}", 16);\n` +
        `var privParams = new ECPrivateKeyParameters(d, curve);\n` +
        `var signer = new SM2Signer();\n` +
        `signer.Init(true, new ParametersWithRandom(privParams, new SecureRandom()));\n` +
        `signer.BlockUpdate(digest, 0, digest.Length);\n` +
        `byte[] sig = signer.GenerateSignature();\n` +
        `string sign = BitConverter.ToString(sig).Replace("-", "").ToLowerInvariant();\n\n` +
        `ECPoint q = curve.Curve.DecodePoint(Hex.Decode("${xencioPublicKey.value}"));\n` +
        `var pubParams = new ECPublicKeyParameters(q, curve);\n` +
        `var sm2 = new SM2Engine(SM2Engine.Mode.C1C3C2);\n` +
        `sm2.Init(true, new ParametersWithRandom(pubParams, new SecureRandom()));\n` +
        `byte[] encKey = sm2.ProcessBlock(keyBytes, 0, keyBytes.Length);\n` +
        `string xencioKeyHeader = BitConverter.ToString(encKey).Replace("-", "").ToLowerInvariant();\n\n` +
        `// headers: x-app-id/x-app-secret/x-customer-code/Content-Type + xencio-key=xencioKeyHeader; body={reqData, sign}`
      );

    case "php":
      return (
        `// 建议使用: packagist 上的 lizhichao/sm-crypto 或 yansongda/gm\n` +
        `// 步骤: 生成 32 位 HEX -> SM4(ECB+PKCS7) 加密原文 -> SM3 摘要 -> SM2 公钥加密三段。\n`
      );

    case "ruby":
      return (
        `# Ruby 可搜索 gm/国密相关库，或调用 C 扩展。流程需与 JS 保持一致。\n` +
        `# 关键点: SM4 ECB+PKCS7, SM3 摘要十六进制, SM2 C1C3C2 模式加密。\n`
      );

    default:
      return "";
  }
};

// 支付制单提交
const submitPayment = async () => {
  if (!appId.value) {
    alert("请填写应用ID (x-app-id)");
    return;
  }

  // if (
  //   !businessTransNo.value ||
  //   !payAmount.value ||
  //   !fromAccountNo.value ||
  //   !fromAccountName.value ||
  //   !toAccountNo.value ||
  //   !toAccountName.value ||
  //   !toAccountType.value
  // ) {
  //   alert(
  //     "请填写必填字段：businessTransNo、payAmount、fromAccountCode、fromAccountName、toAccountCode、toAccountName、toAccountType"
  //   );
  //   return;
  // }

  loading.value = true;
  response.value = "";
  try {
    let bodyToSend: any = null;
    const headers: Record<string, string> = {
      "x-app-id": appId.value,
      "x-app-secret": authorization.value,
      "x-customer-code": customerCode.value,
      "Content-Type": "application/json",
    };

    if (!enableGm.value) {
      bodyToSend = buildPaymentPayload();
    } else {
      // 国密加密请求构建
      // 校验：需填写见知公钥与企业SM2私钥
      if (!xencioPublicKey.value || !sm2PrivateKey.value) {
        response.value = JSON.stringify(
          { error: "请先填写见知公钥与企业SM2私钥后再启用国密加密。" },
          null,
          2
        );
        loading.value = false;
        return;
      }

      const originalPayload = buildPaymentPayload();
      const customPubKey =
        "MFkwEwYHKoZIzj0CAQYIKoEcz1UBgi0DQgAEuUBPcixwduqpHRYxbihNJAi/ud4unQhz7Xt2aiJD1eBd8giHzLz/lkaFKONEl3mbbZ27hSgrB8ANFrGjVKcpvw==";
      const rawJson = JSON.stringify(originalPayload);
      const xencioPublicKeyHex = normalizeSm2PublicHex(xencioPublicKey.value);
      const customPrivHex = normalizeSm2PrivateHex(sm2PrivateKey.value);
      const customerPubKeyHex = normalizeSm2PublicHex(customPubKey);
      const sm4KeyUtf8 = "sJsFLadeCgUqUSps"; //randomSm4Key();
      const sm4KeyHex = Array.from(new TextEncoder().encode(sm4KeyUtf8))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
      const xencioKeyHeader = Base64.fromUint8Array(
        hexToBytes(sm2Encrypt(sm4KeyUtf8, xencioPublicKeyHex))
      );
      console.log("sm4Key: " + sm4KeyUtf8);
      console.log("sm4KeyHex: " + sm4KeyHex);
      console.log("sm4KeyEncrypted: " + xencioKeyHeader);
      const reqDataHex = sm4Lib.encrypt(rawJson, sm4KeyHex);
      console.log("reqDataHex: " + reqDataHex);
      const reqData = Base64.fromUint8Array(hexToBytes(reqDataHex));
      const sign = sm2Lib.doSignature(rawJson, customPrivHex, {
        der: true,
        hash: true,
      });
      // const decryptReqData = sm4Lib.decrypt(reqDataHex, sm4KeyHex);
      // const doVerifySignature = sm2Lib.doVerifySignature(
      //   rawJson,
      //   sign,
      //   customerPubKeyHex,{der:true,hash:true}
      // );
      // ？
      headers["xencio-key"] = xencioKeyHeader;
      bodyToSend = { reqData, sign };

      console.log("rawJson: " + rawJson);
      console.log("reqData: " + reqData);
      console.log("sign: " + sign);
    }
    if (acceptHeader.value) headers["Accept"] = acceptHeader.value;

    const res = await fetch(serverUrl + "/api/v2/payment/commonPay", {
      method: "POST",
      headers,
      body: JSON.stringify(bodyToSend),
    });

    const text = await res.text();
    if (enableGm.value) {
      // 尝试解析国密响应
      try {
        const encKey = res.headers.get("xencio-key") || "";
        const sm2PrivHex = normalizeSm2PrivateHex(sm2PrivateKey.value);
        const sm4KeyRespUTF8 = sm2Decrypt(
          bytesToHex(Base64.toUint8Array(encKey)),
          sm2PrivHex
        );
        const sm4KeyRespHex = Array.from(
          new TextEncoder().encode(sm4KeyRespUTF8)
        )
          .map((b) => b.toString(16).padStart(2, "0"))
          .join("");
        const json = JSON.parse(text || "{}");
        const respDataHex = bytesToHex(
          Base64.toUint8Array(json.respData || "")
        );
        const originResp = sm4Lib.decrypt(respDataHex, sm4KeyRespHex || "");
        const xencioPubHex = normalizeSm2PublicHex(xencioPublicKey.value);
        const verified = sm2Lib.doVerifySignature(
          originResp,
          json.sign || "",
          xencioPubHex,
          { der: true, hash: true }
        );
        response.value = JSON.stringify({ verified, originResp }, null, 2);
      } catch (e) {
        response.value = text; // 回退显示原始文本
      }
    } else {
      response.value = text;
    }
  } catch (error) {
    console.error("请求失败:", error);
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
/* 添加任何需要的自定义样式 */
</style>
